import mapboxgl from "mapbox-gl";

// Mapbox access token
export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1Ijoic2l0ZW5zYyIsImEiOiJjbDV2dHlja3MwZDdiM2lwOWtqaGJ4dTNnIn0.baIM03zTvYrPzEJZOlDtYw";

// Tọa độ tâm Việt Nam
export const VIETNAM_CENTER = [105.25, 16.0];

// Giới hạn trên dưới (Nam - Bắc) để view luôn nằm trong khu vực Việt Nam
// maxBounds: [[west, south], [east, north]]
export const VIETNAM_MAX_BOUNDS = [
  // 24 và 8 giới hạn trên dưới
  // 113.4 giới hạn bên phải che Sounth China Sea
  [87.46, 8.352440565710396],
  [113.4, 24.0],
];

// Cấu hình mặc định cho Map
export const DEFAULT_MAP_OPTIONS = {
  style: "mapbox://styles/mapbox/streets-v11",
  zoom: 4.4,
  minZoom: 3.5,
  maxBounds: VIETNAM_MAX_BOUNDS,
  attributionControl: false,
};

// Dữ liệu GeoJSON cho quần đảo Hoàng Sa và Trường Sa
export const VIETNAM_ISLANDS_DATA = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [112.2, 16.5], // Tọa độ Hoàng Sa
      },
      properties: {
        title: "Quần đảo\nHoàng Sa",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [114.3, 10.0], // Tọa độ Trường Sa
      },
      properties: {
        title: "Quần đảo\nTrường Sa",
      },
    },
  ],
};

// Cấu hình layer cho islands labels
export const ISLANDS_LABELS_LAYOUT = {
  "text-field": ["get", "title"],
  "text-font": ["Open Sans Regular", "Arial Unicode MS Regular"],
  "text-size": 11,
  "text-justify": "center",
  "text-anchor": "center",
};

export const ISLANDS_LABELS_PAINT = {
  "text-color": "#000000",
  "text-halo-color": "#ffffff",
  "text-halo-width": 2,
};

export const addVietnamIslandsLayers = (map) => {
  // Source cho GeoJSON biên giới Hoàng Sa - Trường Sa
  map.addSource("vietnam-hoangsa-truongsa-source", {
    type: "geojson",
    data: "/hoangsa-truongsa.json",
  });

  // Layer fill cho biên giới
  map.addLayer({
    id: "vietnam-hoangsa-truongsa-fill",
    type: "fill",
    source: "vietnam-hoangsa-truongsa-source",
    paint: {
      "fill-color": "#ffffff",
      "fill-opacity": 0.1,
    },
  });

  // Source cho label quần đảo
  map.addSource("vietnam-islands", {
    type: "geojson",
    data: VIETNAM_ISLANDS_DATA,
  });

  // Layer label cho quần đảo
  map.addLayer({
    id: "islands-labels",
    type: "symbol",
    source: "vietnam-islands",
    layout: ISLANDS_LABELS_LAYOUT,
    paint: ISLANDS_LABELS_PAINT,
  });
};

export const createMap = (containerId, center, extraOptions = {}) => {
  document.getElementById(containerId).innerHTML = "";
  mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

  const map = new mapboxgl.Map({
    container: containerId,
    center: center,
    ...DEFAULT_MAP_OPTIONS,
    ...extraOptions,
  });

  map.addControl(new mapboxgl.NavigationControl());

  // bổ sung để giới hạn maxBounds trên mọi mức DPI/scaling
  map.once("load", () => {
    map.resize();
    map.fitBounds(extraOptions.maxBounds || VIETNAM_MAX_BOUNDS, {
      padding: 0,
      animate: false,
    });
    const bounds = map.getBounds();
    const currentEast = bounds.getEast();
    const targetEast = 113.4;
    if (currentEast < targetEast) {
      // Dịch tâm sang phải một khoảng = targetEast - currentEast
      const shift = targetEast - currentEast;
      const currentCenter = map.getCenter();
      map.setCenter([currentCenter.lng + shift, currentCenter.lat]);
    }
    // Set maxBounds cứng với east = 113.4
    const finalBounds = map.getBounds();
    map.setMaxBounds([
      [finalBounds.getWest(), finalBounds.getSouth()],
      [targetEast, finalBounds.getNorth()],
    ]);
  });

  return map;
};
